import './utils/ConsoleInterceptor'; // ⚑ Must be first — installs global console override
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './theme/variables.css';
import { Preferences } from '@capacitor/preferences';
import { WEB_VERSION } from './utils/constants';

// Web-only one-time cleanup for users upgrading from a build that persisted
// auth/PII to localStorage — both raw keys (old `localStorage.setItem(...)`)
// and `CapacitorStorage.*` keys (old `Preferences.set(...)` writes, which on
// web land in localStorage). Re-runs whenever WEB_VERSION bumps so adding a
// newly-discovered legacy key + bumping the const wipes it for all returning
// users. Native is skipped — Preferences there is OS-sandboxed, not localStorage.
try {
  const isWeb = !(window as any).Capacitor?.isNativePlatform?.();
  // console.log(`Running on web platform: ${isWeb}, window.Capacitor: ${(window as any).Capacitor}  `);
  if (isWeb && window.localStorage.getItem('storageVersion') !== WEB_VERSION) {
    const legacyKeys = [
      // Raw keys written by old localStorage.setItem(...) calls
      'token',
      'email',
      'phone',
      'authToken',
      'refreshToken',
      'accessToken',
      // CapacitorStorage.* keys written by old Preferences.set(...) calls
      'CapacitorStorage.token',
      'CapacitorStorage.email',
      'CapacitorStorage.phone',
      'CapacitorStorage.authToken',
      'CapacitorStorage.refreshToken',
      'CapacitorStorage.accessToken',
    ];
    for (const k of legacyKeys) window.localStorage.removeItem(k);
    window.localStorage.setItem('storageVersion', WEB_VERSION);
  }
} catch {
  /* ignore — private mode / storage disabled */
}

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
// Place this at the top level, e.g., in index.tsx or App.tsx
(window as any).setFCMTokenFromNative = async (token: string) => {
  console.log("🔑 New FCM Token received:", token);
  // Store token to the Preferences API if needed
  await Preferences.set({ key: 'fcmToken', value: token });
  (window as any).fcmToken = token;
  // Optionally, trigger a custom event if you want to listen elsewhere
  window.dispatchEvent(new CustomEvent('fcm-token', { detail: token }));
};
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
